const PALETTE = ['#4E28B5', '#B5285E', '#28965B', '#B57628', '#2870B5', '#8A5A1E', '#7C5CD6', '#1E8A8A'];

export function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}
